export const environment = {
    production: true,
    APP_HOST: 'https://backend.kokimart.com/api',
    BASE_URL: 'https://backend.kokimart.com/uploads',
    API_URL: 'https://backend.kokimart.com',
    TRUE_ORDER_API_URL : 'https://1522800.true-order.com/WebReporter/api/v1',
    TRUE_ORDER_AUTH_TOKEN : 'E194583FC566FAD221C20E97A4BB624B13DDB314777F1DC71EF7BD0CB598DF0864FCD983744BFE16'
    // APP_HOST: 'http://localhost:5000/api',
    // BASE_URL: 'http://localhost:5000/uploads',
    // API_URL: 'http://localhost:5000'
};
